module.exports = __webpack_public_path__ + "static/1.ce879f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/work/cityatlas/img/1.png
// module id = 200
// module chunks = 278102253565233